<template>
  <product-form :product="product"
                :loading="loading"
                @submit="updateProduct">
  </product-form>
</template>
<script>
  import ProductForm from './ProductForm';
  import ProductService from 'src/services/ProductService';

  export default {
    name: 'product-edit',
    props: {
      product: {
        type: Object,
        default: () => {
          return {
            job_days: 0
          }
        }
      }
    },
    components: {
      ProductForm
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
      async updateProduct(product) {
        this.loading = true
        try {
          await ProductService.update(product.id, product);
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
